import store from './module/store'

export default {
	name: 'checkin-lionheart',
	store: store,
	routes: []
}